/**
 * Registers `@hsus-dev/session-policy` SessionManager logout callback.
 * All policy expiries use app-only logout (no MSAL `logoutRedirect`).
 * **Absolute** expiry notifies peer portals (`emitAuthLogoutSignal`); idle and cross-tab do not.
 * Explicit user sign-out also fans out via `LogoutService`.
 * `App.tsx` navigates to `/session-expired` or `/login` per `SessionEvent.LogoutTriggered`.
 *
 * Must render under `AuthProvider`.
 */
import { useEffect } from 'react';
import { SessionLogoutReason } from '@hsus-dev/session-policy';
import { registerSessionLogoutCallback } from '../../services/session.service';
import { useAuth } from '../../context/authReactContext';

export function SessionPolicyLogoutRegistrar(): null {
  const auth = useAuth();

  useEffect(() => {
    registerSessionLogoutCallback((reason: string) => {
      const notifyPeerPortals = reason === SessionLogoutReason.Absolute;
      void auth.logout({ notifyPeerPortals });
    });
  }, [auth]);

  return null;
}
